import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSecurityModals } from '../../context/SecurityModalsContext';

// Landing route for the "Reset Transaction PIN" link in the pin reset OTP and
// pin expiring emails. When an already signed in user follows the link, we
// open the Forgot PIN modal for them and drop them back on the dashboard.
// Unauthenticated visitors are handled a layer up by App.js, which sends any
// unknown path to the login screen.
export default function ResetTransactionPinLanding() {
    const navigate = useNavigate();
    const { openForgotPin } = useSecurityModals();

    useEffect(() => {
        openForgotPin();
        navigate('/', { replace: true });
    }, [navigate, openForgotPin]);

    return null;
}
